<template>
  <div class="rule" :class="{ inApp: $root.$data.isApp || $root.miniprogram }">
    <common-title titleName="活动规则" :bcColor="'#F7F8FC'" :zIndex="1000"></common-title>
    <div class="rule-content" v-if="introduction" v-html="introduction"></div>
    <EmptyData v-if="!introduction" txtcont="该活动已下架~" />
  </div>
</template>

<script>
import EmptyData from './component/emptyData';
import { reqCardInfo } from '@/api/collectCard/index';

export default {
  data() {
    return {
      introduction: null,
    };
  },
  components: {
    EmptyData
  },

  computed: {},
  created() {
    this.getData();
  },

  mounted() {
    document.title = '活动规则';
  },

  methods: {
    async getData() {
      const { teacherCode = 'ZY' } = this.$route.query;
      const res = await reqCardInfo(teacherCode);
      if (res?.code === 0) {
        this.introduction = res.data?.description;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rule {
  // background-color: #f7f8fc;
  padding-top: 140px;

  &.inApp {
    padding-top: 10px;
  }



  .rule-content {
    width: 678px;
    margin: 0 auto;
    background: #fff;
    border-radius: 14px;
    padding: 36px;

    ::v-deep img {
      width: 100%;
    }

    ::v-deep p {
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
      color: #333;
      word-wrap: break-word; /* IE */
      overflow-wrap: break-word; /* 其他浏览器 */ 
    }

  }
}
</style>
